export default class PopupMaster {
	constructor(selector) {
		this.element = null;
		this.setBySelector(selector);
	}

	/**
	 * Назначить попап.
	 */
	setByElement(element) {
	    this.element = element;
	}

	/**
	 * Назначить попап.
	 */
	setBySelector(selector) {
	    this.element = document.querySelector(`${selector}`);
	}

	/**
	 * Скрыть попап.
	 */
	hide() {
		if (!this.element) {
			console.error('this.element is empty');
			return;
		}
	    this.element.style.display = 'none';
	    document.body.classList.remove('oc-hidden');
	}

	/**
	 * Скрыть все попапы.
	 */
	_hideAll() {
	    const elementsList = document.querySelectorAll(`div.popup`);
		elementsList.forEach(function(elementItem) {
			let obPopup = new PopupMaster();
			obPopup.setByElement(elementItem);
			obPopup.hide();
		});
	}

	/**
	 * Показать попап.
	 */
	show() {
		if (!this.element) {
			console.error('this.element is empty');
			return;
		}
		this._hideAll();
	    this.element.style.display = 'flex';
	    document.body.classList.add('oc-hidden');
	}
}